import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRadium, gtmEvent } from "higher-order-components"
import { Heading, Button, InputText } from "components"
import { gtmMyMazdaLoginActionTypes } from "store/gtm-events"
import spinnerSvg from "./spinner.svg"

class MyMazdaLogin extends Component {
  static propTypes = {
    heading: PropTypes.string,
    description: PropTypes.string,
    endpoint: PropTypes.string,
    redirectUrl: PropTypes.string,
    vinRego: PropTypes.string,
    errorMessageNOTFOUND: PropTypes.string,
    errorMessageMULTIPLERESULTS: PropTypes.string,
    errorMessageNOTSUPPORTED: PropTypes.string,
    gtmEvent: PropTypes.func
  }

  static defaultProps = {
    endpoint: "/api/mymazdalogin?vinRego=",
    errorMessageNOTFOUND:
      "Unfortunately we were unable to identify your vehicle from the details entered, or no service data exists. Please verify the vehicle details entered and try again, or contact your local Mazda dealer.",
    errorMessageMULTIPLERESULTS:
      "Sorry, no result can be displayed because more than one result exists in Mazda’s database. Please enter your VIN and try again or contact your local Mazda dealer.",
    errorMessageNOTSUPPORTED:
      "Unfortunately the VIN/Rego number you entered is not supported. Please verify the vehicle details entered and try again, or contact your local Mazda dealer."
  }

  constructor(props) {
    super(props)
    this.state = {
      vinOrRegoInput: props.vinRego ? props.vinRego : "",
      displaySpinner: false,
      errorMessage: props.errorMessage
    }

    this.setVinOrRego = (e) => {
      this.setState({ vinOrRegoInput: e.target.value.trim(), errorMessage: "" })
    }

    this.navigate = (data) => {
      const paramNames = [
        "vin",
        "rego",
        "modelCode",
        "exterior",
        "grade",
        "engine",
        "drive",
        "colourCode",
        "transmission",
        "nameplate",
        "series"
      ]
      const url = new window.URL(window.location)
      paramNames.forEach(n => url.searchParams.set(n, data[n]))
      window.location = this.props.redirectUrl + "?" + url.searchParams.toString()
    }

    this.fetchLogin = () => {
      this.setState({
        errorMessage: "",
        displaySpinner: true
      })
      const options = {
        method: "POST",
        credentials: "include",
        headers: {
          "content-type": "application/json"
        },
        body: "{}"
      }
      const url = this.props.endpoint + "?vinrego=" + encodeURIComponent(this.state.vinOrRegoInput)
      fetch(url, options)
        .then((response) => {
          if (response.status === 200) return response.json()

          throw new Error(`Unfortunately the service is unavailable. Please try again later (Status ${response.status}).`)
        })
        .then((json) => {
          if (json.errorMessage || json.errorCode) {
            // Fire GTM event when submission failed
            this.props.gtmEvent({
              gtmID: gtmMyMazdaLoginActionTypes.FAIL_LOGIN,
              gtmPayload: { isVin: this.state.vinOrRegoInput.length > 6 }
            })
            const messages = {
              NOTFOUND: this.props.errorMessageNOTFOUND,
              MULTIPLERESULTS: this.props.errorMessageMULTIPLERESULTS,
              NOTSUPPORTED: this.props.errorMessageNOTSUPPORTED
            }
            const errorMessage = json.errorMessage || messages[json.errorCode]
            this.setState({
              displaySpinner: false,
              errorMessage
            })
          } else {
            // Only fire gtm event if the submission is successful
            this.props.gtmEvent({
              gtmID: gtmMyMazdaLoginActionTypes.SUBMIT_LOGIN,
              gtmPayload: { isVin: this.state.vinOrRegoInput.length > 6 }
            })
            this.setState(
              {
                errorMessage: null
              },
              () => this.navigate(json)
            )
          }
        })
        .catch((error) => {
          this.setState({
            displaySpinner: false,
            errorMessage: error.message
          })
        })
    }
  }

  render() {
    const { heading, description } = this.props

    return (
      <div style={{ backgroundColor: "white", padding: "3em" }}>
        <div style={{ maxWidth: "70em", textAlign: "center", margin: "auto" }}>
          <div style={{ padding: "2em 0" }}>
            <Heading value={heading} size="large" textAlign="center" />
          </div>
          <div
            style={{ fontWeight: 300, lineHeight: 1.8 }}
            dangerouslySetInnerHTML={{ __html: description }} />
          <div style={styles.regoInputContainer}>
            <div style={styles.regoInput}>
              <InputText
                onKeyDown={(e) => {
                  e.key === "Enter" && this.fetchLogin()
                }}
                label="ENTER VIN OR REGO"
                value={this.state.vinOrRegoInput}
                onChange={this.setVinOrRego} />
            </div>
            <Button
              styleName="black"
              display="block"
              label="View details"
              onClick={this.fetchLogin}
              disabled={!this.state.vinOrRegoInput || this.state.displaySpinner}
              fullWidth />
          </div>
          {this.state.displaySpinner && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "2em"
              }}>
              <img src={spinnerSvg} style={{ width: "5em", height: "5em" }} />
            </div>
          )}
          {this.state.errorMessage && <div style={styles.error}>{this.state.errorMessage}</div>}
        </div>
      </div>
    )
  }
}

export default withRadium(gtmEvent())(MyMazdaLogin)

const styles = {
  error: {
    textAlign: "center",
    margin: "auto",
    backgroundColor: "#fffff0",
    border: "solid 1px #cccccc",
    borderRadius: "3px",
    marginTop: "1em",
    marginBottom: "1em",
    padding: "2em",
    lineHeight: 1.8
  },
  regoInputContainer: {
    width: "100%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 768px)": {
      flexDirection: "row",
      maxWidth: "30em",
      alignItems: "center"
    }
  },
  regoInput: {
    flex: "1 1 100%",
    marginRight: "0em",
    "@media (min-width: 768px)": {
      marginRight: "2em"
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/mymazda-login/index.jsx